// お客さん側（application.js）と管理画面（admin.js）の両方で、最初に 1 回だけ動かすもの。
// 管理画面は以前 application.js を丸ごと読み込んでこれらを動かしていたが、お客さん側の
// React アプリ一式まで抱えて重くなっていたので、要るものだけをここに切り出した（2026-10）
//  - @rails/ujs: data-confirm、method: :delete のリンク、remote: true のフォーム
//  - ActiveStorage: 管理画面の画像のダイレクトアップロード（direct_upload: true）
//  - Bugsnag: 画面の JS のエラー通知（お客さん側の ErrorBoundary は ReactApp.tsx で plugin-react を使う）
import * as Rails from "@rails/ujs";
import * as ActiveStorage from "@rails/activestorage";
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

try {
    // 2 回呼ぶと例外になる（rails-ujs has already been loaded）
    Rails.start();
} catch (e) { }
ActiveStorage.start();

Bugsnag.start({
    apiKey: 'c2c391f38e5ce19bc2b88afd2f836a12',
    plugins: [new BugsnagPluginReact()],
    releaseStage: import.meta.env.MODE,
    endpoints: {
        notify: 'https://bugsnag.matzlika.co.jp/notify',
        sessions: 'https://bugsnag.matzlika.co.jp/sessions',
    }
});
